module.exports = __webpack_public_path__ + "components/collaborations-header/static/header--small@2x-cbf8b81fcf135a579318ba2a636d175b.jpg";